// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"PopupArrow_tooltipArrow__Svzd5","bottomTooltipArrow":"PopupArrow_bottomTooltipArrow__JBlN5","topTooltipArrow":"PopupArrow_topTooltipArrow__ZuOI5"};